import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { PrivacyPolicy } from '@core/models/privacy-policy.model';

@Injectable()
export class PrivacyPolicyEntityService extends EntityCollectionServiceBase<PrivacyPolicy> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('PrivacyPolicy', serviceElementsFactory);
  }
}
